import { styled } from 'twin.macro';

export const TimerWrapper = styled.div`
  background-color: white;
  text-align: center;
  margin-top: 20px;
  padding: 20px 5px;
  border-radius: 3px;
  direction: initial;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;

  ${({ inForm }) =>
    inForm &&
    `
    margin-top: 0;
  `}

  @media screen and (min-width: 768px) {
    padding: 30px 10px;
  }

  ${({ formWidth, inPreviewMobile }) =>
    (formWidth <= 35 || inPreviewMobile) &&
    `
    padding: 20px 5px;
  `}
`;

export const TimeCounter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-size: 25px;
  font-weight: 600;
  color: #777;

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 5px;
    font-size: 90%;
    font-weight: 500;
    font-family: 'Inter' !important;
    color: ${({ inForm, timerIsAlmostDead }) => (inForm && timerIsAlmostDead ? 'brown' : '#0b819c')};
    padding: 0 15px;
    background-color: white;
    border-radius: 3px;
    max-width: 70px;
    width: 15%;
    height: 60px;

    ${({ timerDisplay }) =>
      timerDisplay === 'banner' &&
      `
      box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    `}

    > span {
      font-size: 10px;
      padding: 0 10px;
      color: #777;
      font-family: 'Inter' !important;
      font-weight: normal;
    }

    ${({ inForm }) =>
      inForm &&
      `
      font-family: var(--font-family) !important;

      > span {
        font-family: var(--font-family) !important;
      }
    `}
  }

  ${({ enableTimer, timerPosition }) =>
    enableTimer &&
    timerPosition === 'bottom' &&
    `
    flex-direction: column-reverse;
    padding-bottom: 0 !important;
  `}

  @media screen and (min-width: 768px) {
    gap: 15px;
    font-size: 30px;

    > div {
      font-size: 30px;
      gap: 10px;
      width: 80px;
      min-width: 80px;
      height: 80px;

      > span {
        font-size: 13px;
      }
    }
  }

  ${({ formWidth, inPreviewMobile }) =>
    (
      // formWidth <= 35 || 
      inPreviewMobile) &&
    `
    gap: 5px !important;
    font-size: 25px !important;

    > div {
      gap: 5px;
      font-size: 90%;
      padding: 0 10px;
      max-width: 70px;
      min-width: 50px;
      height: 60px;

      > span {
        font-size: 10px;
      }
    }
  `}
`;

export const TimerDescription = styled.p`
  padding-top: 20px;
  font-family: 'Inter' !important;
  font-size: 10px;
  font-weight: 500;
  color: #333;
  max-width: 80%;
  text-align: center;
  margin: 0 auto;

  ${({ inForm }) =>
    inForm &&
    `
    font-family: var(--font-family) !important;
  `}

  @media screen and (min-width: 768px) {
    font-size: 13px;
  }

  ${({ inPreviewMobile }) =>
    inPreviewMobile &&
    `
    font-size: 12px !important;
  `}
`;
